import { Box } from '@mui/material';
import { memo, PropsWithChildren, ReactElement } from 'react';

export const FilterPanelContainer = memo(function ({ children }: PropsWithChildren): ReactElement {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
      }}
    >
      {children}
    </Box>
  );
});

export const FilterPanelHeaderLayout = memo(function ({ children }: PropsWithChildren): ReactElement {
  return (
    <Box
      sx={{
        padding: '1rem 0rem 0rem 1rem',
        position: 'sticky',
        top: '0',
        zIndex: '1',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        background: 'background.paper',
        borderTopLeftRadius: 'inherit',
        borderTopRightRadius: 'inherit',
      }}
    >
      {children}
    </Box>
  );
});

export const FilterPanelBodyLayout = memo(function ({ children }: PropsWithChildren): ReactElement {
  return <Box sx={{ flex: 1, overflow: 'auto' }}>{children}</Box>;
});

export const FilterPanelFooterLayout = memo(function ({ children }: PropsWithChildren): ReactElement {
  return (
    <Box
      sx={{
        display: 'flex',
        position: 'sticky',
        bottom: 0,
        width: '100%',
        bgcolor: 'background.paper',
        flexDirection: 'row',
        justifySelf: 'flex-end',
        justifyContent: 'space-evenly',
        gap: 2,
        alignItems: 'center',
        borderTop: '1px solid #e0e0e0',
      }}
    >
      {children}
    </Box>
  );
});
